<app-header></app-header>
<div class="principal-container">
  <div class="second-container">
    <h1 class="principal-title">Historial de eventos</h1>
    <div class="opciones">
      <!-- <div
        (click)="getOptionSeleted('todos')"
        class="opcion"
        [ngClass]="{ 'opcion-seleted': this.activeOption === 'todos' }"
      >
        Todos los eventos
        <div [ngClass]="{ 'line-option': this.activeOption === 'todos' }"></div>
      </div> -->
      <div
        (click)="getOptionSeleted('propios')"
        class="opcion"
        [ngClass]="{ 'opcion-seleted': this.activeOption === 'propios' }"
      >
        Listado de eventos
        <div
          [ngClass]="{ 'line-option': this.activeOption === 'propios' }"
        ></div>
      </div>
      <!-- <div
        (click)="getOptionSeleted('invitaciones')"
        class="opcion"
        [ngClass]="{ 'opcion-seleted': this.activeOption === 'invitaciones' }"
      >
        Invitaciones
        <div
          [ngClass]="{ 'line-option': this.activeOption === 'invitaciones' }"
        ></div>
      </div> -->
    </div>
  </div>
  <div class="options-container-todos" *ngIf="activeOption === 'todos'">
    <div class="eventos-container">
      <div class="cards-container">
        <div class="row">
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <div class="icono">
                <mat-icon class="icon-description">edit</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="options-container-invitaciones"
    *ngIf="activeOption === 'invitaciones'"
  >
    <div class="eventos-container">
      <p class="title-option">
        Colaborar
      </p>
      <div class="line-events"></div>
      <div class="cards-container">
        <div class="row">
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <div class="icono">
                <mat-icon class="icon-description">edit</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="eventos-container">
      <p class="title-option">
        Asistir
      </p>
      <div class="line-events"></div>
      <div class="cards-container">
        <div class="row">
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <div class="icono">
                <mat-icon class="icon-description">edit</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="options-container-propios" *ngIf="activeOption === 'propios'">
    <div class="eventos-container">
      <div class="cards-container">
        <div class="tutorial">
          <a
            class="ver-tutorial"
            href="https://www.youtube.com/watch?v=JPCxIKkCTBI&list=PLszwZZhTuzzsX8wXtykvKWDB_gIDOf_c0"
            target="_blank"
            rel="noopener noreferrer"
            style="margin-top: 10px;"
          >
            Ver tutoriales
          </a>
        </div>
        <div class="row">
          <!-- <div class="col">
            <div
              class="textos crear-evento"
              (click)="openMarketplaceEventModal()"
            >
              <div class="title-crear">Crear marketplace</div>
              <div class="icono-crear-container">
                <img
                  src="../../../../assets/images/add-icon.png"
                  alt=""
                  class="icon-crear"
                />
              </div>
            </div>
          </div>
          <div class="col">
            <div class="textos crear-evento" (click)="openFeriaEventModal()">
              <div class="title-crear">Crear feria</div>
              <div class="icono-crear-container">
                <img
                  src="../../../../assets/images/add-icon.png"
                  alt=""
                  class="icon-crear"
                />
              </div>
            </div>
          </div>
          <div class="col">
            <div
              class="textos crear-evento"
              (click)="openConferenciaEventModal()"
            >
              <div class="title-crear">Crear conferencia</div>
              <div class="icono-crear-container">
                <img
                  src="../../../../assets/images/add-icon.png"
                  alt=""
                  class="icon-crear"
                />
              </div>
            </div>
          </div>
          <div class="col">
            <div
              class="textos crear-evento"
              (click)="openFeriaEscolarEventModal()"
            >
              <div class="title-crear">Crear feria escolar</div>
              <div class="icono-crear-container">
                <img
                  src="../../../../assets/images/add-icon.png"
                  alt=""
                  class="icon-crear"
                />
              </div>
            </div>
          </div> -->
          <div class="col" *ngFor="let m of marketplaces">
            <div
              class="textos"
              [ngClass]="{ 'fondo-gris': m.desactivado_marketplace == 'Si' }"
            >
              <img
                mat-card-image
                src="../../../../assets/images/marketplaces.png"
                class="img-event"
              />
              <div class="icono">
                <button
                  class="btn btn-success"
                  (click)="visitEvent(m.id_marketplace, 'marketplace')"
                  [disabled]="m.desactivado_marketplace == 'Si'"
                >
                  Visitar
                </button>
                <button
                  class="btn btn-success editar"
                  (click)="editEvent(m.id_marketplace, 'marketplace')"
                  [disabled]="m.desactivado_marketplace == 'Si'"
                >
                  Editar
                </button>
              </div>
              <div class="event-name">
                {{ truncateText(m.nombre_marketplace) }}
              </div>
              <div class="caducado" *ngIf="m.desactivado_marketplace == 'Si'">
                Marketplace caducado
              </div>
            </div>
          </div>
          <div class="col" *ngFor="let f of ferias">
            <div
              class="textos"
              [ngClass]="{ 'fondo-gris': f.desactivado_feria == 'Si' }"
            >
            <img *ngIf="f.tipo_feria == 'educativa'" mat-card-image src="../../../../assets/images/Imagen-escolar.JPG"
              class="img-event" />
            <img *ngIf="f.tipo_feria !== 'educativa'" mat-card-image src="../../../../assets/images/ferias-new.png"
              class="img-event" />
              <div class="icono">
                <button
                  class="btn btn-success"
                  (click)="visitEvent(f.id_feria, 'feria', f.tipo_feria)"
                  [disabled]="f.desactivado_feria == 'Si'"
                >
                  Visitar
                </button>
                <button
                  class="btn btn-success editar"
                  (click)="editEvent(f.id_feria, 'feria')"
                  [disabled]="f.desactivado_feria == 'Si'"
                >
                  Editar
                </button>
              </div>
              <div class="event-name">
                {{ truncateText(f.nombre_feria) }}
              </div>
              <div class="caducado" *ngIf="f.desactivado_feria == 'Si'">
                Feria caducada
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
